"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const IconButton_1 = __importDefault(require("@/components/IconButton"));
const SimpleCell_1 = __importDefault(require("../SimpleCell"));
exports.default = react_1.default.memo(function DeletableCell({ align, onDelete, disabled, testId = "" }) {
    return (react_1.default.createElement(SimpleCell_1.default, { variant: "body", align: align, isDeletable: true },
        react_1.default.createElement(IconButton_1.default, { "data-testid": testId, iconSize: 16, icon: fa_1.FaTrashAlt, onClick: onDelete, disabled: disabled }),
        " "));
});
